module.exports = __webpack_public_path__ + "static/media/partners.4d854be2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners.svg
// module id = 2192
// module chunks = 0